define([
	"dojo/_base/declare",
	"csi/prefs/PreferenceView",
], function(declare, PreferenceView) {

	return declare(PreferenceView, {
		customOptions: [
			{name: "canvasCommentsOrientation", formerName: "CanvasCommentsOrientation", value: ""},
			{name: "canvasWithProperties", value: false},
			{name: "canvasWithPropertiesHeight", value: 110},
			{name: "nestedViews", value: null},
			{name: "printComments", omitFromPreview: true, value: false},
			{name: "printHeader", omitFromPreview: true, value: false},
			{name: "printOrientation", formerName: "Orientation", omitFromPreview: true, value: ""},
			{name: "printPaper", formerName: "PaperSize", omitFromPreview: true, value: ""},
			{name: "printAutoScale", omitFromPreview: true, value: true}
		]
	});
});